import http from '../services/http';
import { typeAs } from '../services/utils';
import Str from '../services/str';

export default {
  namespaced: true,

  state: {
    applicationList: [],
    application: null,
    links: null,
    meta: null,
    filter: {
      keyword: '',
      status: '',
      tab: null,
    },
  },

  mutations: {
    CLEAR_ALL(state) {
      state.applicationList = [];
      state.application = null;
      state.tab = null;
    },
    SET_APPLICATIONLIST(state, data) {
      state.applicationList = data.data.map(
        (item) => {
          item.isChecked = false;
          return item;
        },
      );
      state.links = data.links;
      state.meta = data.meta;
    },
    SET_APPLICATION(state, data) {
      state.application = data;
    },
    SET_FILTER(state, data) {
      state.filter = data;
    },
    SET_META(state, data) {
      state.meta = data;
    },
  },

  actions: {
    clear({ commit }) {
      commit('CLEAR_ALL');
    },

    setFilter({ commit }, data) {
      commit('SET_FILTER', data);
    },

    setMeta({ commit }, data) {
      commit('SET_META', data);
    },

    set_Application({ commit }, data) {
      commit('SET_APPLICATION', data);
    },

    find({ commit, state }) {
      let url = `/application-detail?${Str.query(state.filter)}`;
      if (state.meta) {
        url += `&page=${state.meta.current_page}&page_count=${state.meta.per_page}`;
      }
      return http(url)
        .then((response) => {
          response.body.data.map(typeAs('application'));
          return response.body;
        })
        .then((response) => {
          commit('SET_APPLICATIONLIST', response);
        });
    },

    findById({ commit }, id) {
      return http(`/application-detail/${id}`)
        .then((response) => response.body)
        .then(typeAs('application'))
        .then((item) => {
          commit('SET_APPLICATION', item);
        });
    },

    destroy(_, id) {
      return http(`/application-detail/${id}`, { method: 'DELETE' })
        .then((response) => response.body);
    },

    save(_, {
      id, ...data
    }) {
      const request = id
        ? http(`/application-detail/${id}`, { method: 'PUT', data })
        : http('/application-detail', { method: 'POST', data });
      return request.then((response) => response.body);
    },

    changeStatus(_, {
      id, ...data
    }) {
      const request = http(`/application-detail/${id}/status`, { method: 'PUT', data });

      return request.then((response) => response.body);
    },
    /* 設定關聯產品 */
    saveProd(_, {
      id, ...data
    }) {
      const request = id
        ? http(`/application-detail/${id}/setProd`, { method: 'PUT', data })
        : http('/application-detail', { method: 'POST', data });
      return request.then((response) => response.body);
    },
    /* 設定關聯技術 */
    saveTech(_, {
      id, ...data
    }) {
      const request = id
        ? http(`/application-detail/${id}/setTech`, { method: 'PUT', data })
        : http('/application-detail', { method: 'POST', data });
      return request.then((response) => response.body);
    },
  },
};
